<template>
  <div class="row">
    <spinner v-show="!isLoaded"></spinner>
    <div v-show="isLoaded" class="col-xl-6 order-xl-1">
      <card v-show="isLoaded" card-body-classes="table-full-width"  style="height: 500px" no-footer-line>
        <h4 slot="header" class="card-title">Récupération  des Commandes & Clients</h4>
        <div class="row mt-4">

          <div class="col-lg-3 col-md-6 col-12 m-auto">
            <label class="input-label" >Type d'import</label>
            <fg-input class="select mr-auto ml-auto"  name="type" v-model="type_selected">
              <el-select id="role" placeholder="Choisir un type d'article" v-model="type_selected" filterable>
                <el-option v-for="type in type_select_options" :key="type.label" :label="type.label" :value="type.label"></el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-12 text-center">
            <n-button class="btn btn-outline" @click.native="importCommands">Import un fichier</n-button>
            <input v-show="1 === 2" ref="importCommands" v-on:change="onCommandChange" type="file" name="type"/>
          </div>

          <div v-if="import_command!== null" class="col-12 text-center">
            <i class="far fa-file-excel"><span class="ml-2">{{import_command.name}}</span></i>
          </div>

          <div class="col-12 text-center">
            <n-button id="import" :disabled="validateForm" type="primary" :loading="serverResponse" @click.native="importData()">
              Importer
            </n-button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 text-center">
            <div style="display: inline-grid">
              <div v-if="customersCreation !== null" class="ml-4" style="display: inline-flex">
                <svg v-if="customersCreation === false" class="spinner spinner--circle mr-2" style="height: 21px; width: 21px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                <i v-if="customersCreation === true" class="far fa-check-circle" style="color: #8fbc8f; font-size: 20px;"></i>
                <p class="ml-2">{{customersCreation === true ? addedCustomer+' Client(s) créés' : customersCreation === false ? 'Création des clients en cours': ''}}</p>
              </div>

              <div v-if="commandsCreation !== null" class="ml-4" style="display: inline-flex">
                <svg v-if="commandsCreation === false"  class="spinner spinner--circle mr-2" style="height: 21px; width: 21px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                <i v-if="commandsCreation === true" class="far fa-check-circle" style="color: #8fbc8f; font-size: 20px;"></i>
                <p class="ml-2"> {{commandsCreation === true ? addedCommand+' Commandes créés' : commandsCreation === false ? 'Création des commandes en cours': ''}}</p><br/>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"></i>
                <p class="mb-1" v-if="commandsCreation === true">{{addedArticle+' Articles ajoutés à une commande existante'}}</p>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"></i>
                <p class="mb-1" v-if="commandsCreation === true">{{alreadyExist+' Commandes déjà existantes'}}</p>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"></i>
                <p class="mb-1" v-if="commandsCreation === true">{{multipleCommandNumber+' Doublons de numéro de commande'}}</p>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"></i>
                <p class="mb-1" v-if="commandsCreation === true">{{commandsWithoutItems+' Commandes sans articles'}}</p>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"></i>
                <p class="mb-1" v-if="commandsCreation === true">{{commandsWithIncorrectFormat+' Commandes mal formatées'}}</p>
              </div>
              <div v-if="commandsCreation === true" class="ml-4" style="display: inline-flex">
                <i class="ml-4 mr-2 mt-1 fas fa-arrow-right"
                   :style=" totalCommandsRows ===
                   commandsWithIncorrectFormat+
                   commandsWithoutItems+
                   multipleCommandNumber+
                   alreadyExist+
                   addedCommand +
                   addedArticle ? 'color: #8fbc8f':'color: #F2545B'"></i>
                <p class="mb-1"
                   :style=" totalCommandsRows ===
                   commandsWithIncorrectFormat+
                   commandsWithoutItems+
                   multipleCommandNumber+
                   alreadyExist+
                   addedCommand +
                   addedArticle ? 'color: #8fbc8f':'color: #F2545B'"
                   v-if="commandsCreation === true">{{totalCommandsRows+' Lignes parcourus'}}</p>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
    <div v-show="isLoaded" class="col-xl-6 order-xl-1">
      <card v-show="isLoaded" card-body-classes="table-full-width"  style="height: 500px" no-footer-line>
        <h4 slot="header" class="card-title">Récupération  des Abonnements & Adresses MAC M4</h4>
        <div class="row mt-4">
          <div class="col-12 text-center">
            <n-button class="btn btn-outline" @click.native="importSubscriptions">Import un fichier</n-button>

            <input v-show="1 === 2" ref="importSubscriptions" v-on:change="onSubscriptionChange" type="file" name="type"/>
          </div>

          <div v-if="import_subscription!== null" class="col-12 text-center">
            <i class="far fa-file-excel"><span class="ml-2">{{import_subscription.name}}</span></i>
          </div>

          <div class="col-12 text-center">
            <n-button id="import" :disabled="validateSubscriptionForm" type="primary" :loading="serverResponse" @click.native="importSubscriptionsData()">
              Importer
            </n-button>
          </div>
        </div>
      <div class="row mt-4">
      </div>
    </card>
    </div>
  </div>
</template>

<script>
import Authorizable from "@/mixins/authorizable";
import Spinner from "@/components/Spinner/Circle";
import { Select, Option } from 'element-ui'

export default {
  name: "MigrationForm",
  mixins: [Authorizable],
  components: {
    Spinner,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      type_select_options: [
        {label: 'Wiline Carte'},
        {label: 'Standard'},
        {label: 'Horaflex'},
        {label: 'Wiline'},
      ],
      type_selected: 'Standard',

      isLoaded: false,
      import_command: null,
      import_subscription: null,

      serverResponse : false,

      customersCreation: null,
      addedCustomer: 0,

      commandsCreation: null,
      alreadyExist: 0,
      addedCommand: 0,
      addedArticle: 0,
      multipleCommandNumber: 0,
      commandsWithoutItems : 0,
      commandsWithIncorrectFormat :0,
      totalCommandsRows :0,
    };
  },
  computed: {
    validateForm() {
      return this.import_command === null
    },
    validateSubscriptionForm() {
      return this.import_subscription === null
    }
  },
  mounted() {
    this.isLoaded = true
  },
  methods:{
    importCommands (){
      this.$refs.importCommands.click()
    },
    importSubscriptions (){
      this.$refs.importSubscriptions.click()
    },

    onCommandChange(e){
      this.import_command = e.target.files[0];
    },

    onSubscriptionChange(e){
      this.import_subscription = e.target.files[0];
    },
    importSubscriptionsData(){
      alert('importSubscriptionsData')
    },
    importData() {
      this.customersCreation = false
      this.serverResponse = !this.serverResponse

      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      let formData = new FormData();
      formData.append('file', this.import_command);
      formData.append('type', this.type_selected);

      var saveCustomers = new Promise((resolve, reject) => {
        if(this.type_selected === "Wiline Carte"){
          resolve();
        }

        if(this.type_selected === "Wiline"){
          this.axios.post(process.env.VUE_APP_API_BASE_URL+'migration/import/wiline/customers', formData, config).then(response => {
            this.customersCreation = true
            this.addedCustomer = response.data.newCustomer

            this.commandsCreation = false
            resolve();
          })
        } else {
          this.axios.post(process.env.VUE_APP_API_BASE_URL+'migration/import/customers', formData, config).then(response => {
            this.customersCreation = true
            this.addedCustomer = response.data.newCustomer

            this.commandsCreation = false
            resolve();
          })
        }
      })

      saveCustomers.then(() => {
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'migration/import/commands', formData, config).then(response => {

          this.alreadyExist = response.data['Already exist']
          this.addedCommand = response.data['Commands added']
          this.addedArticle = response.data['Article added to existing command']
          this.multipleCommandNumber = response.data['Multiple amount']
          this.commandsWithoutItems = response.data['Commands with no items']
          this.commandsWithIncorrectFormat = response.data['Errors amount']
          this.totalCommandsRows = response.data['Total rows']

          this.commandsCreation = true
        })
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-outline {
  border: 1px solid;
  padding: 10px 22px;
  color: #f96332;
  background: transparent !important;
}


.loader {
  .loader {
      width: 100%;
      padding: 10% 0;
      position: absolute;
      z-index: 999;
      display: flex;
      justify-content: center;
  }
}

$offset: 187;
$duration: 1.4s;
.spinner {
  animation: circle-rotator $duration linear infinite;
* {
  line-height: 0;
  box-sizing: border-box;
}
}
@keyframes circle-rotator {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
}
.path {
  stroke-dasharray: $offset;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation:
  circle-dash $duration ease-in-out infinite,
  circle-colors ($duration*4) ease-in-out infinite;
}
@keyframes circle-colors {
  0% {
    stroke: #35495e;
  }
  25% {
    stroke: #DE3E35;
  }
  50% {
    stroke: #F7C223;
  }
  75% {
    stroke: #0089ff;
  }
  100% {
    stroke: #35495e;
  }
}
@keyframes circle-dash {
  0% {
    stroke-dashoffset: $offset;
  }
  50% {
    stroke-dashoffset: $offset/4;
    transform:rotate(135deg);
  }
  100% {
    stroke-dashoffset: $offset;
    transform:rotate(450deg);
  }
}
</style>